var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"appie-page-title-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"appie-page-title-item"},[_c('h3',{staticClass:"title"},[_vm._v("Terms and conditions")])])])])])])])
}]

export { render, staticRenderFns }